import { FC } from "react";
import { Modal } from "../../../Modal";
import { ThinButton } from "../../../../Buttons/ThinButton/ThinButton";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../Menu/MenuButton";
import { MarkdownWithPlaceholders } from "../../MarkdownWithPlaceholders";
import challengesIcon from '../icons/challenges.png';
import { Button } from "../../../../Buttons/Button/Button";
import { ICustomNotifyRouterProps } from "../CustomNotifyRouter";
import { useDispatch } from "../../../../../hooks";
import { setChallengeButtonBlinkState } from "../../../../../redux/ui";

interface IChallengeRewardNotifyProps extends ICustomNotifyRouterProps {
    title?: string;
    message?: string;
}

export const ChallengeRewardNotify: FC<IChallengeRewardNotifyProps> = (notify) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handler = () => {
        dispatch(setChallengeButtonBlinkState(true));
        notify.closeHandler();
    }

    return (
        <Modal
            name='ChallengeRewardNotify'
            title={ notify.title }
            message={ <MarkdownWithPlaceholders message={notify.message ?? ''} /> }
            icon={challengesIcon}
            button={[
                <ThinButton caption='Хочу ещё награду' handler={ () => { navigate(`/${AppContext.Challenges}`); handler(); } } />,
                <Button caption='Закрыть' type='orange' handler={handler} />,
            ]}
        />
    );
}